import React from "react";
import { gql, useMutation } from "@apollo/client";
import { Dialog } from "@syos-music/common";

import { Typography, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import OrderSidebar from "../index";

export default function RemoveSoundShaping({
  orderId,
  soundShapingId,
  children,
}) {
  const [isOpen, setIsOpen] = React.useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const [removeSoundShaping, { loading }] = useMutation(gql`
    mutation ($orderId: ID!, $soundShapingId: ID!) {
      RemoveSoundShaping(orderId: $orderId, soundShapingId: $soundShapingId) {
        order {
          id

          ...OrderSidebar_order
        }
      }
    }

    ${OrderSidebar.fragments.order}
  `);

  return (
    <>
      {children({ isOpen, open, close })}

      <Dialog open={isOpen} onClose={close}>
        <Dialog.Title color="primary">Attention</Dialog.Title>

        <Dialog.Content>
          <Typography>
            Voulez-vous vraiment supprimer ce bec de la commande ?
          </Typography>
        </Dialog.Content>

        <Dialog.Actions>
          <Button variant="text" onClick={close}>
            Annuler
          </Button>
          <LoadingButton
            onClick={() =>
              removeSoundShaping({
                variables: { orderId, soundShapingId },
              })
            }
            loading={loading}
          >
            Supprimer
          </LoadingButton>
        </Dialog.Actions>
      </Dialog>
    </>
  );
}
